import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import pmsboard from "../../Assets/Projects/pmsboard.png";
import homebuilder from "../../Assets/Projects/homebuilder.png";

import explore from "../../Assets/Projects/explore.png";

import hospitalste from "../../Assets/Projects/hospitalste.png";
import hospitaldashboard from "../../Assets/Projects/hospitaldashboard.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={explore}
              isBlog={false}
              title="Explore Tourism"
              description="Explore and discover historical tourist destinations in Karnataka
              - a travel guide web app for cultural heritage lovers.
              This project was created as a free social service to help tourists and citizens of Karnataka explore and learn about their heritage. It is a humble effort to promote historical awareness and ease travel planning."
              ghLink="https://github.com/mujeebkhan3771/Explore_Trip"
              demoLink="https://explore-trip.onrender.com/listings"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hospitalste}
              isBlog={false}
              title="Hospital Web"
              description="Developed, a hospital management web application. This application allows patients to manage appointments and communicate with hospital managers. It features secure authentication, an intuitive interface for users, and efficient handling of hospital resources. I implemented technologies such as React for the frontend, Node.js/Express for the backend, and MongoDB for the database, creating a responsive and user-friendly platform that enhances the patient-care experience."
              ghLink="https://github.com/mujeebkhan3771/HospitalProject"
              demoLink="https://hospital-project-mmk.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hospitaldashboard}
              isBlog={false}
              title="Hospital Admin Dashboard"
              description="This hospital admin dashboard is a fully functional web application designed to streamline the management of appointments, doctor details, and messages for public hospitals. Developed using the MERN stack, the dashboard provides a dynamic and responsive interface that enables hospital administrators to manage their day-to-day operations efficiently. It features real-time data updates, role-based authentication, and a simple user interface to help manage hospital data with ease."
              ghLink="https://github.com/mujeebkhan3771/HospitalProject"
              demoLink="https://hospital-project-mmk.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={homebuilder}
              isBlog={false}
              title="Home-Real Estate Website"
              description="HomeBuilder is a professional marketing website built for a home construction or real estate development company. It showcases the company’s services, highlights completed projects, features client testimonials, and includes a working contact form for customer inquiries."
              ghLink="https://github.com/mujeebkhan3771/HomeBuilder"
              demoLink="https://mujeebkhan3771.github.io/HomeBuilder"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pmsboard}
              isBlog={false}
              title="Doctor Prescription Management System"
              description="A web-based application designed for doctors to manage patients and prescriptions efficiently. The system auto-generates patient UIDs, provides a searchable dashboard, and stores complete prescription history with date and time. Prescriptions are instantly converted into dynamic medical reports for printing or sharing, saving time and ensuring accuracy. This project highlights my skills in full-stack development, database management, and building real-world healthcare solutions."
              ghLink="https://github.com/mujeebkhan3771/PrescriptionApp"
              demoLink="https://prescription-web-app.netlify.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
